export default "__VITE_ASSET__94750618__"